export const getConsTabs = (acc, cons) => {
	const { consultant, starts_at } = cons;
	const [date] = starts_at.split(' ');
	if (typeof acc[consultant] === 'undefined') acc[consultant] = {};
	if (typeof acc[consultant][date] === 'undefined') acc[consultant][date] = [];
	acc[consultant][date].push(cons);

	return acc;
};

export const consCardParams = cons => {
	const { status } = cons;
	if (status === 'probono')
		return [
			'',
			{
				bg: 'yellow.300',
				borderColor: 'yellow.300',
			},
		];
	if (status === 'booked')
		return [
			'',
			{
				bg: 'teal.600',
				color: 'white',
				borderColor: 'teal.600',
			},
		];
	return ['', {}];
};
